<template>
  <!-- blank — user sees the overlay spinner while we handle the callback -->
</template>

<script>
import axios from 'axios';

export default {
  name: 'ServiceM8Callback',
  data: function () {
    return {
      submitted: false
    }
  },
  mounted () {
    if (this.submitted) return
    this.submitted = true
    this.$store.commit('setOverlay', true);

    const code  = this.$route.query.code;
    const state = this.$route.query.state;

    if (!code || !state) {
      this.errorNotification('ServiceM8 authorisation failed — missing parameters');
      this.$store.commit('setOverlay', false);
      this.$router.push('/settings/account');
      return;
    }

    axios.post('/api/integrations/servicem8/oauth/callback', { code, state })
      .then(() => {
        this.$store.commit('setOverlay', false);
        // Redirect to integrations tab with success flag
        this.$router.push({ path: '/settings/account', query: { sm8_connected: '1', tab: 'integrations' } });
      })
      .catch((error) => {
        const msg = error && error.response && error.response.data && error.response.data.error
          ? error.response.data.error
          : 'Unable to connect with ServiceM8';
        this.errorNotification(msg);
        this.$store.commit('setOverlay', false);
        this.$router.push('/settings/account');
      });
  }
};
</script>
